import React from "react";
import { snakeToCamel } from "utils/caseConvertor";
import {
  TextField,
  Dropdown,
  MultiselectDropdown,
  RadioButtonGroup,
} from "../../Components";
import { conditionalityForObservations } from "utils/conditionalityForObservations";

interface SampleProps {
  panel: any; // replace 'any' with the appropriate type for the 'panel' prop'
  editMode: boolean;
  formikProps: any;
  handleUpdateStatus: any;
}

const AlertTrigger: React.FC<SampleProps> = ({ panel, editMode, formikProps, handleUpdateStatus }) => {

    const onChange = (
        eleName: string,
        value: any,
        name: string,
        type: any,
        inputType: any,
        phoneAnswer?: any
      ) => {
        // setFieldValue(eleName, value);
        if (type === "phone_number" || inputType === "tel") {
          handleUpdateStatus(name, panel.sectionId, phoneAnswer);
        } else {
          handleUpdateStatus(name, panel.sectionId);
        }
      };

  const panelElements =
    panel.templateElements && panel.templateElements.length > 0
      ? panel.templateElements
      : panel.elements && panel.elements.length > 0
        ? panel.elements
        : [];

  const panelName = snakeToCamel(panel.name);

  return (
    <>
      <div className=" gap-4 mb-5">
        {panelElements.map((element: any, index: number) => {
          const {
            name,
              title,
              fieldAs,
              visible = true,
              isRequired = false,
              rows,
              value,
              inputType,
              type,
              placeholder,
              disabled,
              max,
              labelTrue,
              labelFalse,
              choices,
              choicesByUrl,
              visibleIf,
              enableIf,
              setValueIf,
              setValueExpression,
              requiredIf,
              id,
              select_multiple,
              selected_layers,
              selected_shapes,
              answer,
              description,
              defaultValue,
              multiSelect,
              colCount,
              isUpdated,
              maskType,
              maskSettings,
              phoneAnswer,
          } = element;
          const eleName = [panelName, element.name].join(".");
          const error = formikProps.errors[panelName]?.[element.name];
          const touched = formikProps.touched[panelName]?.[name];
          if (visible === false || type === "html" || defaultValue) {
            return;
          }
          switch (element.type) {
            case "phone_number":
              case "text":
                return (
                  <TextField
                    key={index}
                    label={title || name}
                    type={type === "phone_number" ? "tel" : inputType || type}
                    name={name}
                    value={formikProps.values[panelName]?.[name]}
                    handleChange={(value: any, phoneAnswer?: any) => {
                      onChange(
                        eleName,
                        value,
                        name,
                        type,
                        inputType,
                        phoneAnswer
                      );
                    }}
                    handleBlur={() =>
                      formikProps.setFieldTouched(eleName, true, true)
                    }
                    fieldAs={fieldAs}
                    rows={rows}
                    editMode={editMode}
                    placeholder={value}
                    // required={isRequired}
                    error={error}
                    touched={touched}
                    visibleIf={visibleIf}
                    answers={formikProps.values[panelName]}
                    enableIf={
                      enableIf !== null
                        ? conditionalityForObservations(
                            enableIf,
                            formikProps.values[panelName],
                            "enableIf"
                          )
                        : false
                    }
                    setValueIf={setValueIf}
                    setValueExpression={setValueExpression}
                    requiredIf={requiredIf}
                    isUpdated={isUpdated}
                    maskType={maskType}
                    maskSettings={maskSettings}
                    panel={panel}
                    element={element}
                    phoneAnswer={phoneAnswer}
                    disabled={true}
                  />
                );

            default:
              return null; // Or render a default component for unknown types
          }
        })}
      </div>
    </>
  );
};

export default AlertTrigger;
